import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FiSearch,
  FiFileText,
  FiMapPin,
  FiCheckCircle,
  FiClock,
  FiSettings,
} from "react-icons/fi";

const features = [
  {
    title: "Trusted Expertise",
    desc: "With years of experience in the real estate industry, we offer expert guidance tailored to your needs.",
    icon: <FiSearch className="w-6 h-6 text-[#FF5A3C]" />,
  },
  {
    title: "Transparent Dealings",
    desc: "We believe in 100% transparency and ethical practices — no hidden charges, no surprises.",
    icon: <FiFileText className="w-6 h-6 text-[#FF5A3C]" />,
  },
  {
    title: "Prime Property Listings",
    desc: "We offer portfolio of residential, commercial, and investment-ready properties in top locations.",
    icon: <FiMapPin className="w-6 h-6 text-[#FF5A3C]" />,
  },
  {
    title: "End-to-End Support",
    desc: "From site visits to paperwork, financing to legal checks — we guide you at every step.",
    icon: <FiCheckCircle className="w-6 h-6 text-[#FF5A3C]" />,
  },
  {
    title: "Quick Turnaround",
    desc: "We value your time. Our streamlined process ensures faster closures and efficient communication.",
    icon: <FiClock className="w-6 h-6 text-[#FF5A3C]" />,
  },
  {
    title: "Customer-Centric Approach",
    desc: "Your satisfaction is our top priority. We listen, understand, and deliver exactly what you're looking for.",
    icon: <FiSettings className="w-6 h-6 text-[#FF5A3C]" />,
  },
];

const CovanantsSection = () => {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: false, offset: 100 });
    return () => AOS.refresh();
  }, []);

  return (
    <div className="w-full bg-gray-50 px-4 py-16">
      <div className="max-w-screen-xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12" data-aos="zoom-in">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold text-gray-900 mb-4">
            Why <span className="text-[#FF5A3C]">Covenants</span> Developers
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-md leading-relaxed text-center mx-auto">
            At Covenants, We Are Committed To Turning Dreams Into Reality By Providing Exceptional Real Estate Solutions. With A Strong Foundation Of Trust, Expertise, And Innovation, We Help Individuals And Businesses Find The Perfect Properties That Align With Their Goals.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl border border-[#FF5A3C] px-6 py-10 hover:shadow-lg transition-shadow duration-300"
              data-aos="zoom-in"
            >
              <div className="mb-4">
                <div className="w-12 h-12 bg-white shadow-md rounded-md flex items-center justify-center">
                  {feature.icon}
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CovanantsSection;